import createService from "./createService";
import createReport from "./createReport";
import {
    API_ADDRESS_TAOCAN,
    API_ADDRESS_ZHANGHAO,
    API_ADDRESS_ZENGZHI,
    API_ADDRESS_DINGDAN
} from "../state";
var instance = createService();
var server = {
    upaloadFile(data={}){
        // var params = createCommonReport("01050001",data);
        return instance.post(`http://beta-im.wangba518.com:10105/uploadFile`,data,{
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    getFriendList(data={}){ //获取好友列表
        var params = createReport("02020003",data);
        // return new Promise(res=>{
        //     instance.post("",params).then(data=>{
        //         window.caches.open("test").then(cache=>{
        //             cache.put("/test",new Response(data,{status:200}));
        //             res(data);
        //         });
        //     });
        // });
        return instance.post("",params);
    },
    getUserInfo(data={}){//根据token获取用户状态
        var params = createReport("03020011",data);
        return instance.post("",params);
    },
    login(data={}){//登录
        var params = createReport("03020001",data);
        return instance.post("",params);
    },
    register(data={}){//注册
        var params = createReport("03020009",data);
        return instance.post("",params);
    },
    logout(data={}){//登出
        var params = createReport("03020012",data);
        return instance.post("",params);
    },
    // register(data={}){//注册
    //     var params = createReport("03020009",data);
    //     return instance.post("",params);
    // },
    getMeal(data={}){ //获取套餐列表
        var params = createReport("03010008",data);
        return instance.post(API_ADDRESS_TAOCAN,params);
    },
    getModule(data={}){ //获取APP模块
        var params = createReport("03010009",data);
        return instance.post(API_ADDRESS_TAOCAN,params);
    },
    getService(data={}){ //查询服务列表
        var params = createReport("03010005",data);
        return instance.post(API_ADDRESS_TAOCAN,params);
    },
    createOrder(data={}){ //创建订单
        var params = createReport("03030001",data);
        return instance.post(API_ADDRESS_DINGDAN,params);
    },
    payOrder(data={}){ //支付订单
        var params = createReport("03030002",data);
        return instance.post(API_ADDRESS_DINGDAN,params);
    },
    getOrder(data={}){ //获取订单列表
        var params = createReport("03030003",data);
        return instance.post(API_ADDRESS_DINGDAN,params);
    },
    cancelOrder(data={}){ //取消订单
        var params = createReport("03030009",data);
        return instance.post(API_ADDRESS_DINGDAN,params);
    },
    getInviteList(data={}){ //获取邀请列表
        var params = createReport("03020010",data);
        return instance.post(API_ADDRESS_ZHANGHAO,params);
    },
    getInviteList(data={}){ //获取邀请列表
        var params = createReport("03020010",data);
        return instance.post(API_ADDRESS_ZHANGHAO,params);
    },
    createdCDKEY(data={}){ //生成激活码
        var params = createReport("03030011",data);
        return instance.post(API_ADDRESS_DINGDAN,params);
    },
    getAllModules(data={}){ //获取所有模块
        var params = createReport("03010010",data);
        return instance.post(API_ADDRESS_TAOCAN,params);
    },
    changePassword(data={}){ //修改密码
        var params = createReport("03020016",data);
        return instance.post(API_ADDRESS_TAOCAN,params);
    }
}

export default server;